import React from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import AuthProvider from './contexts/AuthProvider';
import { ThemeProvider } from './contexts/ThemeProvider';
import PrivateRoute from './components/PrivateRoute';
import Login from './pages/Login';
// import Dashboard from './pages/Dashboard';
import Products from './pages/Products';
import Resellers from './pages/Resellers';
import Alerts from './pages/Alerts';
import AlertReport from './pages/AlertReport';
import AlertHistory from './pages/AlertHistory';
import Settings from './pages/Settings';
import ProductDetail from './pages/ProductDetail';
import Admin from './pages/Admin';
import { Toaster } from '@/components/ui/toaster';
import './App.css';

/**
 * Main App component
 * Sets up routing and authentication provider
 */
function App() {
  return (
    <ThemeProvider>
      <AuthProvider>
        <Router future={{ v7_startTransition: true, v7_relativeSplatPath: true }}>
          <div className="App">
            <Toaster />
            <Routes>
              {/* Public route for login */}
              <Route path="/login" element={<Login />} />
              {/* Redirect old clerk-login to login */}
              <Route path="/clerk-login" element={<Navigate to="/login" replace />} />
              
              {/* Protected routes */}
              {/* Dashboard route commented out */}
              {/* <Route 
                path="/dashboard" 
                element={
                  <PrivateRoute>
                    <Dashboard />
                  </PrivateRoute>
                } 
              /> */}
              <Route 
                path="/products" 
                element={
                  <PrivateRoute>
                    <Products />
                  </PrivateRoute>
                } 
              />
              <Route
                path="/resellers"
                element={
                  <PrivateRoute>
                    <Resellers />
                  </PrivateRoute>
                }
              />
              <Route
                path="/alerts"
                element={
                  <PrivateRoute>
                    <Alerts />
                  </PrivateRoute>
                }
              />
              <Route
                path="/alerts/:id"
                element={
                  <PrivateRoute>
                    <AlertHistory />
                  </PrivateRoute>
                }
              />
              <Route
                path="/alerts/:id/report/:date"
                element={
                  <PrivateRoute>
                    <AlertReport />
                  </PrivateRoute>
                }
              />
              <Route
                path="/alerts/:id/report"
                element={
                  <PrivateRoute>
                    <AlertReport />
                  </PrivateRoute>
                }
              />
              <Route
                path="/settings"
                element={
                  <PrivateRoute>
                    <Settings />
                  </PrivateRoute>
                }
              />
              <Route 
                path="/product-detail" 
                element={
                  <PrivateRoute>
                    <ProductDetail />
                  </PrivateRoute>
                } 
              />
              {/* Product detail by shopify_id (fallback for compatibility) */}
              <Route 
                path="/product/:shopifyId" 
                element={
                  <PrivateRoute>
                    <ProductDetail />
                  </PrivateRoute>
                } 
              />
              {/* Custom product detail */}
              <Route
                path="/product/custom/:customId"
                element={
                  <PrivateRoute>
                    <ProductDetail />
                  </PrivateRoute>
                }
              />

              {/* Admin panel (staff only) */}
              <Route
                path="/admin/*"
                element={
                  <PrivateRoute staffOnly>
                    <Admin />
                  </PrivateRoute>
                }
              />

              {/* Default redirect to products */}
              <Route path="/" element={<Navigate to="/products" replace />} />
            </Routes>
          </div>
        </Router>
      </AuthProvider>
    </ThemeProvider>
  );
}

export default App;
